import React, { ChangeEvent } from 'react';
import Svg from '@jg/svg';
import * as icons from '@jg/icons';
import classnames from 'classnames';
import { renderSelectOptions } from '../../utils';

type Props = {
  placeholder?: string | null;
  label?: string | null;
  name?: string | null;
  id: string;
  items: Array<string>;
  handleChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  defaultCurrency: string;
};

const DropDown = ({
  items,
  label,
  id,
  handleChange,
  defaultCurrency,
}: Props) => {
  const isDisabled: boolean = items.length <= 1;
  const wrapperClassName: string = classnames({
    'dropdown-wrapper': true,
    'dropdown-wrapper--disabled': isDisabled,
  });
  return (
    <div className={wrapperClassName}>
      <label htmlFor={id}>
        <span className="jg-h3 jg-display-b" data-qa="label">
          {label}
        </span>
        <select
          defaultValue={defaultCurrency}
          id={id}
          onChange={handleChange}
          disabled={isDisabled}
        >
          {items.map(renderSelectOptions)}
        </select>
        {!isDisabled && (
          <Svg
            markup={icons.chevronDownIcon}
            className="jg-icon jg-fill--nobel"
          />
        )}
      </label>
    </div>
  );
};

export default DropDown;
